export type ConfigMap = {
    pass:     string;
    princeId: string;
    rxClaimOauthClientId: string;
    govIdOauthClientId: string;
    azureClientId: string;
    splunkClientId: string;
    baseUrl: string;
    ohidBaseUrl: string;
    govIdBaseUrl: string;
    pingBaseUrl: string;
    azureBaseUrl: string;
    gatewayBaseUrl: string;
}

export let configMap: ConfigMap = {} as ConfigMap;

export function setConfigMap(newConfigMap: ConfigMap) {
    configMap = newConfigMap;
}